import { localToUtc24h } from '../../utils/formatters';

const DAY_SEQUENCE = ['SUN', 'MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT'] as const;

function shiftDay(day: string, dayOffset: number): number | null {
    const dayIndex = DAY_SEQUENCE.indexOf(day as (typeof DAY_SEQUENCE)[number]);

    if (dayIndex === -1) {
        return null;
    }

    return ((dayIndex + dayOffset) % 7 + 7) % 7;
}

export default function ScheduleToCronExpression(schedule: { days: string[]; hour: number | null; minute: number | null; ampm: "AM" | "PM"; }) {

    if (schedule.hour == null || schedule.minute == null || !schedule.days.length) return "";
    // The picker works in the user's local time — convert to UTC for the cron expression
    const { utcHour: hour24, utcMinute: minute, dayOffset } = localToUtc24h(schedule.hour, schedule.minute, schedule.ampm);
    const days = schedule.days
        .map((day) => shiftDay(day, dayOffset))
        .filter((day): day is number => day !== null)
        .sort((a, b) => a - b)
        .join(",");

    if (!days) return "";
    return `${minute} ${hour24} * * ${days}`;
}
